import {
  ParticipateByUserResponseDto,
  ParticipateResponseDto,
} from '@diritto/common/promotion/dtos/promotion-participate.dto';
import { PromotionDto, PromotionItemResponseDto } from '@diritto/common/promotion/dtos/promotion.dto';
import { Http } from '@diritto/common/utils/requester/http';
import { AxiosRequestConfig } from 'axios';

export class PromotionApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getPromotion(promotionId: number, options?: AxiosRequestConfig) {
    const res = await this.http.get<PromotionDto>(`${this.url}/promotions/${promotionId}`, options);
    return res.data;
  }

  async getPromotionItems(promotionId: number, isActive?: boolean, options?: AxiosRequestConfig) {
    const res = await this.http.get<PromotionItemResponseDto>(`${this.url}/promotions/${promotionId}/items`, {
      params: {
        isActive,
      },
      ...options,
    });
    return res.data;
  }

  async getParticipates(promotionId: number, options?: AxiosRequestConfig) {
    const res = await this.http.get<ParticipateResponseDto>(
      `${this.url}/promotions/${promotionId}/participates`,
      options,
    );
    return res.data;
  }

  async getParticipateByUser(promotionId: number, options?: AxiosRequestConfig) {
    const res = await this.http.get<ParticipateByUserResponseDto>(
      `${this.url}/promotions/${promotionId}/participates/me`,
      options,
    );
    return res.data;
  }

  async participate(promotionItemId: number, description?: string, options?: AxiosRequestConfig) {
    const res = await this.http.post(
      `${this.url}/promotions/items/${promotionItemId}/participate`,
      { description },
      options,
    );
    return res.data;
  }
}
